import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Divider from 'material-ui/Divider'
import Messages from '../constants/messages'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired
}

const styles = theme => ({
  root: {
    minWidth: 320,
    maxWidth: 600,
    width: '30%',
    margin: 'auto'
  },
  copyright: {
    display: 'inline-block',
    width: '100%',
    textAlign: 'left'
  },
  divider: {
    marginTop: 25,
    marginBottom: 25
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    padding: 10,
    fontSize: 12
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  nordstromLogo: {
    width: '70%',
    paddingBottom: 30
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  })
})

export class LoggedOut extends Component {

  render() {
    const { classes } = this.props

    return (
      <section>
        <section className={classes.root}>
          <Paper className={classes.paper} elevation={4} id="loggedOut">
            <header className={classes.header}>
              <img
                data-test-id="nordstrom-logo"
                src="https://s3-us-west-2.amazonaws.com/nauth-prod/Design+Assets/nord_logo/nord_logo_black%402x.png"
                className={classes.nordstromLogo}
                alt="nordstrom logo" />
                <Typography className={classes.paddingBot} type="display1">{Messages['uiComponents']['APPLICATION_NAME']}</Typography>
            </header>
            <Divider className={classes.divider} />
            <Typography type="title" gutterBottom>
              {Messages['pageHeaders']['LOGGED_OUT_TITLE']}
            </Typography>
            <Typography>
              {Messages['pageMessages']['LOGGED_OUT_MSG1'] + ' '}
              <a href="/login">{Messages['pageMessages']['LOGGED_OUT_MSG2']}</a>
            </Typography>
          </Paper>
        </section>
        <footer className={classes.footer}>
          <span className={classes.copyright} data-test-id="nordstrom-copy">&copy; {`${(new Date()).getFullYear()} Nordstrom, Inc.`}</span>
        </footer>
      </section>
    )
  }
}

LoggedOut.propTypes = PROP_TYPES

export default withStyles(styles)(LoggedOut)
